import type { InterestRatesApiResponseLegacy, InterestRatesApiResponseModern, PeriodRate, PeriodRateLegacy } from '@shared/models';
import { RateType } from '@shared/models';

export const MAX_LEGACY_API_NON_NHG_RATES_NUMBER = 3;

export function isLegacyFormatApi(data: InterestRatesApiResponseModern | InterestRatesApiResponseLegacy): data is InterestRatesApiResponseLegacy {
  if (!data) throw new Error(`Cannot determine data format, because data is: ${data}`);
  if (!data.periods || data.periods.length === 0) return false;

  return (data.periods[0].rates as ReadonlyArray<PeriodRate | PeriodRateLegacy>).filter((v: PeriodRate | PeriodRateLegacy) => v.type !== RateType.NHG).length <= MAX_LEGACY_API_NON_NHG_RATES_NUMBER;
}
